import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const PieChartOutline = createIcon({
  displayName: 'PieChartOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10.5,6c-4.142,0 -7.5,3.358 -7.5,7.5c0,4.142 3.358,7.5 7.5,7.5c4.142,0 7.5,-3.358 7.5,-7.5h-7.5v-7.5Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M21,10c0,-3.866 -3.134,-7 -7,-7v7h7Z"
        ></path>
      </g>
    </>
  ),
})

const PieChartTwoTone = createIcon({
  displayName: 'PieChartTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none" color="twoToneStrokeColor">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10.5,6c-4.142,0 -7.5,3.358 -7.5,7.5c0,4.142 3.358,7.5 7.5,7.5c4.142,0 7.5,-3.358 7.5,-7.5h-7.5v-7.5Z"
        ></path>
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M21,10c0,-3.866 -3.134,-7 -7,-7v7h7Z"
        ></Box>
      </Box>
    </>
  ),
})

const PieChart: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={PieChartTwoTone} {...props} />

  return <CustomIcon as={PieChartOutline} {...props} />
}

export default memo(PieChart)
